import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import NewSliderComponent from './NewSliderComponent';
const CardCarousel = props => {
  const $ = _c(19);
  const {
    afterSlideFn,
    beforeSlideFn,
    children,
    className,
    deviceOverride,
    disableSliding,
    fabricGridControls: t0,
    isMobileMaterialSwatches: t1,
    navType,
    slideIndex,
    variant,
    visibleSlides,
    fullHeight: t2
  } = props;
  const fabricGridControls = t0 === undefined ? false : t0;
  const isMobileMaterialSwatches = t1 === undefined ? false : t1;
  const fullHeight = t2 === undefined ? false : t2;
  let finalVisibleSlides = visibleSlides ? visibleSlides.content ? visibleSlides.content : visibleSlides : 2;
  const {
    isMobile
  } = useScreen();
  if (isMobile && !isMobileMaterialSwatches) {
    finalVisibleSlides = 1;
  }
  const t3 = variant === "reviews-list";
  let t4;
  if ($[0] !== className || $[1] !== t3) {
    t4 = classNames({
      "[&_.slider-slide]:!min-h-[400px] [&_.slider-slide]:!h-fit [&_.slider-slide]:max-[569px]:!min-h-[275px] [&_.slider-list]:max-[568px]:!overflow-y-scroll": t3,
      className
    });
    $[0] = className;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== afterSlideFn || $[4] !== beforeSlideFn || $[5] !== children || $[6] !== deviceOverride || $[7] !== disableSliding || $[8] !== fabricGridControls || $[9] !== finalVisibleSlides || $[10] !== fullHeight || $[11] !== isMobileMaterialSwatches || $[12] !== navType || $[13] !== slideIndex || $[14] !== variant) {
    t5 = <NewSliderComponent afterSlideFn={afterSlideFn} beforeSlideFn={beforeSlideFn} deviceOverride={deviceOverride} disableSliding={disableSliding} fabricGridControls={fabricGridControls} finalVisibleSlides={finalVisibleSlides} isMobileMaterialSwatches={isMobileMaterialSwatches} navType={navType} slideIndex={slideIndex} variant={variant} fullHeight={fullHeight}>{children}</NewSliderComponent>;
    $[3] = afterSlideFn;
    $[4] = beforeSlideFn;
    $[5] = children;
    $[6] = deviceOverride;
    $[7] = disableSliding;
    $[8] = fabricGridControls;
    $[9] = finalVisibleSlides;
    $[10] = fullHeight;
    $[11] = isMobileMaterialSwatches;
    $[12] = navType;
    $[13] = slideIndex;
    $[14] = variant;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t4 || $[17] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};
CardCarousel.propTypes = {
  afterSlideFn: PropTypes.func,
  beforeSlideFn: PropTypes.func,
  children: PropTypes.arrayOf(PropTypes.shape({
    src: PropTypes.string,
    url: PropTypes.string,
    value: PropTypes.string
  })),
  deviceOverride: PropTypes.bool,
  disableSliding: PropTypes.bool,
  fabricGridControls: PropTypes.bool,
  isMobileMaterialSwatches: PropTypes.bool,
  navType: PropTypes.string,
  slideIndex: PropTypes.number,
  variant: PropTypes.oneOf(['blog-slider', 'collections-slider', 'material-swatches-sidebar', 'reviews-list']),
  visibleSlides: PropTypes.number,
  fullHeight: PropTypes.bool
};
export default CardCarousel;